module.exports = __webpack_public_path__ + "img/supermarket.81a094d5.svg";